(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('uDetails', uDetailsFactoryFunc);

    function uDetailsFactoryFunc($http, Path) {
        var user;
        return {
            init: function(u) {
                user = u;
            },
            get: function() {
                return $http.get(Path.getApiPath('/auth/user')).then(function() {
                    return user;
                }, function() {

                });
            }
        };
    }
})();